import {
  Stack,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import {
  Expense,
  Investigation,
  Patient,
  Person,
  Voucher,
  VoucherRecord
} from "app/api/type";
import { PageCardComponent } from "modules/core/components/page-card.component";
import React from "react";

interface TransferVoucherComponentProps {
  voucherDetails: {
    patient: Patient | null;
    person: Person | null;
    voucher: Voucher;
    entries: {
      voucherRecord: VoucherRecord;
      investigation: Investigation | null;
      expense: Expense | null;
    }[];
  };
}

export const TransferVoucherComponent: React.FC<
  TransferVoucherComponentProps
> = (props: TransferVoucherComponentProps) => {
  return (
    <Stack>
      <Stack spacing="6">
        <PageCardComponent>
          <TableContainer>
            <Table variant="simple" size="sm">
              <TableCaption placement="top">
                Transaction {props.voucherDetails.voucher.id}
              </TableCaption>
              <Thead>
                <Tr>
                  <Th>Sl.</Th>
                  <Th width="30%">Details</Th>
                  <Th>Amount</Th>
                  <Th>Total</Th>
                </Tr>
              </Thead>

              <Tbody>
                {props.voucherDetails.entries.map((voucherEntry, index) => {
                  return (
                    <Tr>
                      <Td>{index + 1}</Td>
                      <Td>Cash to Bank Transfer</Td>

                      <Td>৳ {voucherEntry.voucherRecord.basePrice}</Td>

                      <Td>৳ {voucherEntry.voucherRecord.totalPrice}</Td>
                    </Tr>
                  );
                })}
                <Tr bgColor="gray.600" color="white" fontWeight={"bold"}>
                  {" "}
                  <Td></Td>
                  <Td>Grand Total </Td>
                  <Td>=</Td>
                  <Td>
                    ৳{" "}
                    {props.voucherDetails.entries.reduce(
                      (totalPrice, voucherEntry) =>
                        totalPrice + voucherEntry.voucherRecord.totalPrice,
                      0
                    )}
                  </Td>
                  <Td></Td>
                </Tr>
                <Tr bgColor="gray.100" fontWeight={"bold"}>
                  {" "}
                  <Td></Td>
                  <Td>Paid </Td>
                  <Td>=</Td>
                  <Td>৳ {props.voucherDetails.voucher.paidAmount}</Td>
                  <Td></Td>
                </Tr>{" "}
                {/* <Tr bgColor="gray.100" fontWeight={"bold"}>
                    <Td></Td>
                    <Td>Due </Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                    <Td>=</Td>
                    <Td>৳ {props.voucherDetails.voucher.dueAmount}</Td>
                    <Td></Td>
                  </Tr> */}
              </Tbody>
            </Table>
          </TableContainer>
        </PageCardComponent>
      </Stack>
    </Stack>
  );
};
